module.exports = __webpack_public_path__ + "media/src/images/purchase_voucher_header-17823adccaf64797eb80dc1f897598e9.jpg";